import { render, staticRenderFns } from "./add_hb.vue?vue&type=template&id=4c8f3d65&"
import script from "./add_hb.vue?vue&type=script&lang=js&"
export * from "./add_hb.vue?vue&type=script&lang=js&"
import style0 from "./add_hb.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports